module.exports = {
  WarehouseNo: 'หมายเลขการรับเข้า',
  Warehouse: 'ชื่อคลังสินค้า',
  WarehouseInDate: 'เวลารับเข้าจริง',
  State: 'สถานะการรับเข้า',
  PackageWarehouseInDate: 'บรรจุภัณฑ์ - เวลารับเข้าจริง',
  PackageWarehouseOutDate: 'บรรจุภัณฑ์ - เวลาส่งออกจริง',
  ReceiptNumber: 'หมายเลขใบรับ',
  ReceiptNo: 'เลขที่ใบรับ',
  PortOfDestination: 'ท่าปลายทาง',
  StorageDate: 'เวลาเข้าเก็บ',
  DeliveryDate: 'เวลานำออก',
  StorageDay: 'วันที่เข้าเก็บ',
  ActStorageDay: 'วันที่เข้าเก็บจริง',
  DeliveryDay: 'วันที่นำออก',
  ActDeliveryDay: 'วันที่นำออกจริง',
  InputTime: 'เวลาบันทึก',
  DataEntryClerk: 'ผู้บันทึก',
  NumberOfCases: 'จำนวนชิ้น',
  Weight: 'น้ำหนัก',
  Volume: 'ปริมาตร',
  ComputationIsAffectedByDampness: 'ชำรุด/เปียกชื้น',
  IsNotComputationIsAffectedByDampness: 'ชำรุด/เปียกชื้นหรือไม่',
  ComputationIsAffectedByDampnessNum: 'จำนวนชิ้นที่ชำรุด/เปียกชื้น',
  IntoTheWarehousePhotos: 'รูปภาพการรับเข้า',
  WarehouseName: 'ชื่อคลังสินค้า',
  DeliveryMode: 'วิธีการนำออก',
  Warehouseman: 'พนักงานคลัง',
  WarehouseLocation: 'ที่เก็บ',
  StorageLocation: 'ที่เก็บ',
  TemperatureRequirement: 'ข้อกำหนดอุณหภูมิ',
  DeliveryCmp: 'บริษัทขนส่ง',
  IssueOrNot: 'นำออกหรือไม่',
  PalletSum: 'จำนวนพาเลท',
  ReceiveDc: 'ได้รับเอกสารหรือไม่',
  LicensePlate: 'ป้ายทะเบียน',
  DescriptionOfGoods: 'รายละเอียดสินค้า',
  HandlingOpinions: 'ความคิดเห็นการจัดการ',
  Remark: 'หมายเหตุ',
  SealingWeight: 'น้ำหนักซีล',
  Driver: 'คนขับรถ',
  DriverPhone: 'โทรศัพท์คนขับรถ',
  IsTheGoodsClosed: 'เป็นสินค้าซีลหรือไม่',
  WarehouseInformation: 'ข้อมูลคลังสินค้า',
  CargoDetails: 'รายการสินค้า',
  CargoPhotos: 'รูปภาพสินค้า',
  OperationRequirements: 'ข้อกำหนดการปฏิบัติงาน',
  SelectFile: 'เลือกไฟล์',
  DeleteFile: 'ลบไฟล์',
  AddCargo: 'เพิ่มสินค้า',
  Detail: 'รายละเอียด',
  Summary: 'สรุป',
  FillData: 'เติม',
  maintenanceAllType: 'หมายเลขลังและข้อมูลสินค้า',
  maintenanceContainerNoType: 'เฉพาะหมายเลขลัง',
  maintenanceWeightAndSizeType: 'เฉพาะข้อมูลสินค้า',
  DeleteCargo: 'นำสินค้าออก',
  JobNumberInformation: 'ข้อมูลหมายเลขงาน',
  Statistics: 'สถิติ',
  Number: 'จำนวนตั๋ว',
  QuantityActual: 'จำนวนชิ้นจริง',
  WeightActual: 'น้ำหนักจริง',
  CubageActual: 'ปริมาตรจริง',
  WarehouseOutState: 'สถานะการออกคลัง',
  WarehouseInState: 'สถานะการเข้าคลัง',
  WarehouseIn: 'เข้าคลัง',
  WarehouseOut: 'ออกคลัง',
  NewWarehouseFee: 'เพิ่มค่าคลังใหม่',
  WarehousePhotos: 'รูปภาพคลังสินค้า',
  StorageDayCanNotBeNull: 'วันที่เข้าคลังไม่สามารถเว้นว่างได้',
  DeliveryDayCanNotBeNull: 'วันที่ออกคลังไม่สามารถเว้นว่างได้',
  WarehouseInSuccess: 'เข้าคลังสำเร็จแล้ว',
  WarehouseOutSuccess: 'ออกคลังสำเร็จแล้ว',
  NoChoiceWarehouseToBePrinted: 'ไม่ได้เลือกข้อมูลคลังที่ต้องการพิมพ์!',
  PleaseSelectTheWarehousingNoticeToBeDeleted: 'กรุณาเลือกใบแจ้งเข้าคลังที่ต้องการลบ',
  WarehousingNotice: 'ใบแจ้งเข้าคลัง',
  AreYouSureToDeleteThisWarehousingNotice: 'แน่ใจหรือไม่ที่จะลบใบแจ้งเข้าคลังนี้?',
  DeleteWarehousingNotice: 'ลบใบแจ้งเข้าคลัง',
  ImportingData: 'กำลังนำเข้าข้อมูล',
  ThisOperationIsAnAsynchronousImport: 'การดำเนินการนี้เป็นการนำเข้าแบบอะซิงโครนัส คุณสามารถดูผลการนำเข้าได้ใน "ที่เก็บไฟล์ -> บันทึกการอัปโหลด"',
  ViewResults: 'ดูผลลัพธ์',
  BatchImportWarehousing: 'นำเข้าเข้าคลังแบบกลุ่ม',
  BatchImportWarehousingData: 'นำเข้าข้อมูลเข้าคลังแบบกลุ่ม',
  NoWarehouseReceiptSelected: 'ไม่ได้เลือกใบเข้าคลัง',
  Checklist: 'ตรวจสอบใบสั่ง',
  ReturnGoods: 'ส่งคืน',
  OnlySave: 'บันทึกเท่านั้น',
  Save: 'บันทึก',
  SaveAndWeigh: 'บันทึกและชั่งน้ำหนัก',
  SaveAndChecklist: 'บันทึกและตรวจสอบใบสั่ง',
  WeighAndChecklist: 'ชั่งน้ำหนักและตรวจสอบใบสั่ง',
  PoOriginalOrderNo: 'PO(หมายเลขใบสั่งเดิม)',
  ServiceChannel: 'ช่องทางบริการ',
  DestinationDeliveryMethod: 'วิธีการจัดส่งปลายทาง',
  OverseasWarehouse: 'คลังสินค้าต่างประเทศ',
  DestinationCountry: 'ประเทศปลายทาง',
  Weigh: 'ชั่งน้ำหนัก',
  ReceivingWarehouse: 'คลังสินค้ารับของ',
  CommissionNo: 'หมายเลขมอบหมาย',
  OverseasWarehouseCode: 'รหัสคลังสินค้าต่างประเทศ',
  RemoteWarehouse: 'คลังสินค้าห่างไกล',
  boxLengthPlaceholder: 'ยาว',
  boxWidthPlaceholder: 'กว้าง',
  BoxHeightPlaceholder: 'สูง',
  SizeNotZero: 'ความยาว, ความกว้าง, ความสูง, จำนวนหีบห่อ ไม่สามารถน้อยกว่าหรือเท่ากับ 0 ได้',
  EstEnteringAmazonWarehouse: 'เวลาที่คาดว่าจะเข้าคลัง Amazon',
  ChargingMethod: 'วิธีการคิดค่าบริการ',
  Total: 'รวม',
  WeighTime: 'เวลาชั่งน้ำหนัก',
  weighCheckMsg: 'ข้อมูลการเข้าคลังนี้ได้{0}แล้ว ไม่สามารถชั่งน้ำหนักได้',
  ChecklistTime: 'เวลาตรวจสอบเอกสาร',
  ReturnGoodsTime: 'เวลาคืนสินค้า',
  CourierServicesCompany: 'บริษัทขนส่ง',
  Electric: 'มีแบตเตอรี่หรือไม่',
  Magnetic: 'มีแม่เหล็กหรือไม่',
  Powdery: 'เป็นผงหรือไม่',
  Liquid: 'เป็นของเหลวหรือไม่',
  BatchMaintenance: 'บำรุงรักษาแบบกลุ่ม',
  PickingGoods: 'เลือกสินค้าตามข้อมูลลูกค้า',
  AdjustChargeWeight: 'ปรับน้ำหนักการคิดค่าบริการ',
  ContainerNo: 'หมายเลขลัง',
  BoxesNumber: 'จำนวนลัง',
  SingleBoxWeight: 'น้ำหนักลังเดียว (กก.)',
  DialogSingleBoxWeight: 'น้ำหนักลังเดียว (กก.)',
  BoxLength: 'ความยาวลัง (ซม.)',
  BoxWidth: 'ความกว้างลัง (ซม.)',
  BoxHeight: 'ความสูงลัง (ซม.)',
  UnitRate: 'ราคาประกาศ (ต่อชิ้น)',
  Quantity: 'จำนวนที่ประกาศ (ต่อลัง)',
  BoxSize: 'ขนาดลังเดียว',
  HsCode: 'รหัสศุลกากร',
  Brand: 'แบรนด์',
  BrandType: 'ประเภทแบรนด์',
  ModelNo: 'รุ่น',
  MaterialQuality: 'วัสดุ',
  Purpose: 'การใช้งาน',
  SalesLink: 'ลิงก์ขาย',
  SalesPrice: 'ราคาขาย',
  PictureUrl: 'รูปภาพ',
  WeightKg: 'น้ำหนัก (กก.)',
  CargoType: 'ประเภทสินค้า',
  ProductDescription: 'คำอธิบายสินค้า',
  CheckWeighTime: 'ข้อมูลการเข้าคลังนี้ได้ชั่งน้ำหนักแล้ว ต้องการอัปเดตข้อมูลการชั่งน้ำหนักหรือไม่?',
  ChecklistTimeTip: 'เวลาตรวจสอบเอกสาร【{0}】ต้องไม่น้อยกว่าเวลาชั่งน้ำหนัก【{1}】 โปรดตรวจสอบ',
  ReturnReason: 'สาเหตุการคืนสินค้า',
  ReturnGoodsTips: 'มีข้อมูล{0} โปรดยืนยันว่าต้องการคืนสินค้าหรือไม่?',
  ChecklistResult: 'ผลการตรวจสอบเอกสาร',
  ModifiedReason: 'สาเหตุการแก้ไขเอกสาร',
  WsTjRemark: 'คำอธิบายการแก้ไขเอกสาร',
  WsTjReason: 'เหตุผลการลบเอกสาร',
  WsTjDelRemark: 'คำอธิบายการลบเอกสาร',
  ModifiedWsTjTips: 'กรณีมีเหตุผลอื่น ต้องระบุเพิ่มเติม',
  FaceOrderPrintTime: 'เวลาพิมพ์ใบปะหน้าขนส่ง',
  CourierNumber: 'หมายเลขพัสดุ',
  RefContainerNo: 'หมายเลขกล่องอ้างอิง',
  isWeigh: 'ชั่งน้ำหนักหรือไม่',
  isChecklist: 'ตรวจสอบรายการหรือไม่',
  isReturn: 'คืนสินค้าหรือไม่',
  ChecklistTip: 'ข้อมูลที่เลือกมีข้อมูลที่ยังไม่ได้ชั่งน้ำหนัก กรุณาตรวจสอบ',
  cannotEditOutData: 'ข้อมูลที่ออกจากคลังแล้วไม่สามารถแก้ไขได้',
  alreadyChecklist: 'รายการนี้ได้รับการตรวจสอบแล้ว กรุณาตรวจสอบ',
  delChecklistData: 'มีข้อมูลที่ตรวจสอบแล้ว ไม่สามารถลบได้',
  repeatPackingData: 'มีข้อมูลที่บรรจุกล่องแล้ว ไม่สามารถบรรจุซ้ำได้ กรุณาตรวจสอบ',
  ChecklistTipOne: 'ข้อมูลที่เลือกมีข้อมูลที่ยังไม่ได้ชั่งน้ำหนัก ต้องการตรวจสอบรายการหรือไม่',
  RegistrationSlip: 'ลงทะเบียนใบปะหน้า',
  ContainerNoEditor: 'แก้ไขหมายเลขกล่องสินค้า',
  PerContainerNo: 'คำนำหน้าหมายเลขกล่อง (FBA):',
  boxNum: 'จำนวนกล่อง:',
  boxSeq: 'ลำดับกล่อง:',
  boxSeqType3: 'ความยาว 3 หลัก',
  boxSeqType6: 'ความยาว 6 หลัก',
  boxSeqTooLong: 'ลำดับกล่องเกินค่าสูงสุด [{0}] กรุณาตรวจสอบ',
  duplicateContainerNo: 'หมายเลขกล่องสินค้า [{0}] มีอยู่แล้ว กรุณากรอกใหม่',
  shipmentIdNotNull: 'กรุณาบันทึก shipment Id ก่อน!',
  boxesNumberNotNull: 'กรุณาบันทึกจำนวนกล่องก่อน!',
  cargoChineseNameNotNull: 'กรุณาบันทึกชื่อสินค้า (จีน) ก่อน!',
  cargoEnglishNameNotNull: 'กรุณาบันทึกชื่อสินค้า (อังกฤษ) ก่อน!',
  singleBoxWeightNotNull: 'กรุณาบันทึกน้ำหนักกล่องสินค้าเดี่ยวก่อน!',
  boxesSizeNotNull: 'กรุณาบันทึกขนาดกล่องเดี่ยวก่อน!',
  boxSeqNotNull: 'กรุณาบันทึกลำดับกล่องก่อน',
  deleteTheDetailRecord: 'รายการทั้งหมดในรายการปัจจุบันจะถูกล้าง ต้องการดำเนินการต่อหรือไม่',
  overwriteTheDetailRecord: 'รายการทั้งหมดในรายการปัจจุบันจะถูกแทนที่ด้วยข้อมูลลูกค้า ต้องการดำเนินการต่อหรือไม่',
  overwriteTheDetailRecordByJobRelated: 'รายการทั้งหมดในรายการปัจจุบันจะถูกแทนที่ด้วยข้อมูลลูกค้า ต้องการดำเนินการต่อหรือไม่',
  continuePicking: 'ยังไม่ได้ตรวจสอบรายการ ต้องการบรรจุกล่องต่อหรือไม่',
  continueReturnGoods: 'หลังจากคืนสินค้าแล้วจะไม่ดำเนินการรวมตู้คอนเทนเนอร์ ต้องการดำเนินการต่อหรือไม่',
  editShipmentId: 'หมายเลขกล่องสินค้าไม่ตรงกับ ShipmentId ต้องการรีเฟรชหมายเลขกล่องสินค้าหรือไม่',
  editActJmt: 'รายละเอียดกล่องสินค้ามีค่าอยู่แล้ว ไม่อนุญาตให้แก้ไขข้อมูลสรุปน้ำหนักและขนาด!',
  storageAgeEdit: 'ปรับอายุคลัง',
  storageAgeEditDay: 'วัน (คำนวณอัตโนมัติ/จริง)',
  storageAgeEditWeek: 'สัปดาห์ (คำนวณอัตโนมัติ/จริง)',
  Packing: 'บรรจุกล่อง',
  ExWarehouse: 'ออกจากคลัง',
  weightOpCannotChecklist: 'ไม่อนุญาตให้บันทึก หากต้องการตรวจสอบรายการ กรุณาคลิกปุ่ม【ชั่งน้ำหนักและตรวจสอบ】',
  saveCheckContainerNoFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกหมายเลขกล่องสินค้า กรุณาตรวจสอบ!',
  saveCheckShipmentIdFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึก Shipment Id กรุณาตรวจสอบ!',
  saveCheckQuantityFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกน้ำหนักกล่องสินค้าเดี่ยว กรุณาตรวจสอบ!',
  saveCheckBoxLengthFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกความยาวกล่องสินค้า กรุณาตรวจสอบ!',
  saveCheckBoxWidthFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกความกว้างกล่องสินค้า กรุณาตรวจสอบ!',
  saveCheckBoxHeightFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกความสูงกล่องสินค้า กรุณาตรวจสอบ!',
  saveCheckChineseCargoNameFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกชื่อสินค้า (จีน) กรุณาตรวจสอบ!',
  saveCheckEnglishCargoNameFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกชื่อสินค้า (อังกฤษ) กรุณาตรวจสอบ!',
  saveCheckBrandFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกยี่ห้อ กรุณาตรวจสอบ!',
  saveCheckBrandTypeFail: 'รายละเอียดมีข้อมูลที่ยังไม่ได้บันทึกประเภทยี่ห้อ กรุณาตรวจสอบ!',
  FaceListCheckExpressDelivery: 'วิธีการจัดส่งที่ปลายทางไม่ใช่บริการด่วน ไม่จำเป็นต้องลงทะเบียนใบปะหน้า',
  FaceListCheckTip: 'ไม่มีข้อมูลการชั่งน้ำหนัก ต้องการลงทะเบียนข้อมูลใบปะหน้าการส่งด่วนต่อหรือไม่?',
  PackingTipOne: 'มีข้อมูลสินค้าที่ถูกส่งคืน ไม่สามารถบรรจุกล่องได้ โปรดตรวจสอบ',
  PackingTipTwo: 'ข้อมูลที่เลือกมีข้อมูลที่การตรวจสอบเอกสารไม่ผ่าน ต้องการดำเนินการบรรจุกล่องต่อหรือไม่?',
  ExWarehouseTip: 'ข้อมูลที่เลือกมีข้อมูลที่ออกจากคลังแล้ว โปรดตรวจสอบ',
  LabelingTime: 'เวลาติดฉลาก',
  Labeling: 'ติดฉลาก',
  Pallet: 'ต้องการพาเลทหรือไม่',
  PalletNo: 'หมายเลขพาเลท',
  DaycareInformation: 'ข้อมูลการพาเลท',
  PreDeliveryTime: 'วันที่จัดส่งตามประมาณการ',
  ActDeliveryTime: 'วันที่จัดส่งจริง',
  LogisticsNo: 'หมายเลขติดตามโลจิสติกส์',
  OperationStatus: 'สถานะการดำเนินงานคลังต่างประเทศ',
  LogisticsNoEnd: 'หมายเลขติดตามโลจิสติกส์(ระยะสุดท้าย)',
  palletContainerNum: 'จำนวนกล่องที่พาเลทแล้ว',
  otherContainerNum: 'จำนวนกล่องแบบไม่ถาด',
  updateIssueRemarks: 'หมายเหตุการออกคลัง',
  DateOfService: 'วันที่จัดส่ง',
  onWarehouseInCheck: 'ข้อมูลที่เลือกมีข้อมูลที่ไม่อยู่ในสถานะรอเข้าคลัง โปรดตรวจสอบ',
  PleaseChooseADataEntry: 'กรุณาเลือกข้อมูลอย่างน้อย 1 รายการ!',
  ExternallyImportedDataCannotEdit: 'ข้อมูลที่นำเข้าจากภายนอก แก้ไขไม่ได้',
  CannotEditExternalData: 'ข้อมูลที่นำเข้าจากภายนอก แก้ไขไม่ได้',
  PleaseChooseDesignatedData: 'กรุณาเลือกข้อมูลที่กำหนด',
  CargoWareDoorstepVehicleDrivingButton: 'CargoWare-ฟังก์ชันธุรกิจ-จุดรับส่งลูกค้า-เส้นทางรถยนต์ (คลิกปุ่ม)',
  PlateOrderNumberCannotEmpty: 'หมายเลขทะเบียนรถและหมายเลขใบตราส่งต้องไม่ว่างเปล่า',
  NoAvailableAtThisTime: 'ขณะนี้ยังไม่มีข้อมูลที่เกี่ยวข้อง'
}
